import React from 'react'

import { B2 } from '@zet/design-system/typography'
import { i18n } from '@zet/localization'

import CommissionType from './commissionType'

interface Props {
  commissionType: string
  brandCommission: string | number
}

const PayoutTextForLastDayHi: React.FC<Props> = (props) => {
  const { commissionType, brandCommission } = props
  return (
    <B2 className="text-grays-50 mt-2">
      {i18n.t('myLeads.completeSaleToday')}
      <CommissionType
        commissionType={commissionType}
        brandCommission={brandCommission}
      />
      {i18n.t('myLeads.completeSaleTodayEarnUpto')}
    </B2>
  )
}

const PayoutTextForLastDayEn: React.FC<Props> = (props) => {
  const { commissionType, brandCommission } = props

  return (
    <B2 className="text-grays-50 mt-2">
      {i18n.t('myLeads.completeSaleToday')}
      <CommissionType
        commissionType={commissionType}
        brandCommission={brandCommission}
      />
    </B2>
  )
}

const PayoutTextForLastDay: React.FC<Props> = (props) => {
  if (i18n.locale === 'en') {
    return <PayoutTextForLastDayEn {...props} />
  } else {
    return <PayoutTextForLastDayHi {...props} />
  }
}

export default PayoutTextForLastDay
